<template>
  <div>
    <div>
      <div class="d-flex align-items-center mb-2">
        <i class="fas fa-book-user mr-2 text-orange"></i>
        <div class="color-gray-7 font-16 font-weight-bold">
          Información del Libro
        </div>
      </div>
      <div class="row">
        <div
          v-for="(prop, key) in properties"
          :key="key"
          class="col-12 col-md-4"
        >
          <span class="data-title">{{ prop.name | empty }}:</span>
          <p>{{ prop.value | empty }}</p>
        </div>
      </div>
    </div>
    <div class="my-4 py-1">
      <div class="d-flex align-items-center mb-2">
        <i class="fas fa-info-circle mr-2 text-orange"></i>
        <div class="color-gray-7 font-16 font-weight-bold">
          Descripción del Libro
        </div>
      </div>
      <div>
        <span class="data-title">Descripción:</span>
        <p>{{ item.description | empty }}</p>
      </div>
    </div>
    <div>
      <div class="d-flex align-items-center mb-2">
        <i class="fas fa-map-marker-alt mr-2 text-orange"></i>
        <div class="color-gray-7 font-16 font-weight-bold">
          Información de Locación
        </div>
      </div>
      <div>
        <span class="data-title">Datos de Ubicación / Dirección:</span>
        <p>{{ item.address | empty }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import PROPERTIES from "@/utils/constants/inventory/bookItemProperties";

export default {
  name: "AdditionalInfo",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    properties() {
      return this.item.properties
        ?.reverse()
        .filter(x => x.name !== PROPERTIES.ReadingMedium);
    }
  }
};
</script>
<style lang="scss"></style>
